<template>
</template>

<script>
import surveysService from "@/services/Surveys/surveys";

export default {
  name: "Home",
  components: {
  },
  data: function() {
    return {
    };
  },
  methods: {
  },
  created: function() {
    if(this.$route.query.r != null){
      this.$router.push({
        name: "surveys-review",
        query: { r: this.$route.query.r }
      });
      return;
    }
    else if(this.$route.query.q != null){
      this.$router.push({
        name: "surveys",
        query: { q: this.$route.query.q }
      });
      return;
    } else if (this.$route.query.word != null) {
      //console.log(this.$route.query);
      let word = this.$route.query.word;
      let questionKey = this.$route.query.questionKey;
      //call to open panel survey
      surveysService
        .getSurveyWebOpenPanel(word, questionKey)
        .then(response => {
          console.log(response);
          //message
          this.message = response.data.message;
          //status
          this.status = response.data.status;

          //check if there is a survey to answer
          if (this.status === "created" && this.message != null) {
            const keys = Object.keys(this.$route.query);
            let params = {};
            let queryParam = this.$route.query;
            for (const key of keys) {
              params[key] = queryParam[key];
            }
            //add q
            params.q = this.message;
            delete params.word;
            delete params.questionKey;
            console.log(params);
            this.$router.push({
              name: "surveys",
              query: params
            });
            return;
          } else {
            this.$router.push({
              name: "no-survey",
              params: { message: this.message }
            });
            return;
          }
        })
        .catch(e => {
          console.log(e);
          this.$notifyError("Error obteniendo encuesta");
        });
    } else {
      this.$router.push({
        name: "notFound"
      });
      return;
    }
  }
};
</script>
